<span class="addTherapy Auto_Add_Therapy" *ngIf="!addNewTherapy && !addNewTrial" (click)="addNewTherapy =!addNewTherapy"><i class="icon icon__plus"></i> Add Therapy</span>
<span class="addTherapy Auto_Add_Trial" *ngIf="!addNewTherapy && !addNewTrial && EnableAddingTrials" (click)="addNewTrial =!addNewTrial"><i class="icon icon__plus"></i> Add Trial</span>
<div *ngIf="addNewTherapy" class="info-section">
  <p-autoComplete #autoComplete
    class="form-item"
    required="true"
    [ngModel]="selectedTherapy"
    (ngModelChange)="updateTherapy($event)"
    [suggestions]="options"
    dataKey="code"
    emptyMessage="Not Found"
    placeholder="Therapy"
    inputStyleClass="form-control text-override Auto_Input_Therapy"
    styleClass="therapy-search"
    field="CommonName"
    [minLength]="true"
    (completeMethod)="searchTherapy($event)"
    genTooltip
    [tooltipPosition]="'top'"
    [tooltipText]="'Therapy'"
    [forceSelection]="!allowTherapyFreeText"
    [appendToBody] ="true"
    inputId="autocomplete-input"
  >
  
    <ng-template let-value pTemplate="item">
      <gen-suggestions-template [object]="value"
                                [fieldTemplate]="'additional-parenthesis'"
                                [fieldsToDisplay]="['Synonyms']"
                                [mainValue]="value['CommonName']">
      </gen-suggestions-template>
    </ng-template>
  </p-autoComplete>
    <span genTooltip
        [tooltipPosition]="'top'"
        [tooltipText]="'Target'"
        [appendToBody] ="true"
        >
      <input
        class="form-control Auto_Input_Target"
        placeholder="Target"
        maxlength="{{targetMaxLength}}"
        [(ngModel)]="newTherapy.target[0]"/>
    </span>
</div>

<div *ngIf="addNewTrial" class="info-section">
    <span genTooltip
        [tooltipPosition]="'top'"
        [tooltipText]="'Trial ID'"
        [appendToBody] ="true"
        >
      <input #newTrail
        class="form-control Auto_Input_TrialID"
        placeholder="Trial ID"
        [(ngModel)]="newTrial.trialID"/>
    </span>
    <span genTooltip
        [tooltipPosition]="'top'"
        [tooltipText]="'Trial ID'"
        [appendToBody] ="true"
        >
      <input
        class="form-control Auto_Input_Target"
        placeholder="e.g. target and/or arm"
        [(ngModel)]="newTrial.target"/>
    </span>    
</div>

<div *ngIf="addNewTherapy || addNewTrial" class="buttons-section">
  <i class="icon fa fa-times-circle delete Auto_Discard_Therapy" (click)="discard()"></i>
  <i class="icon fa fa-check-circle add Auto_Save_Therapy" (click)="add(addNewTherapy)"></i>
</div>



